export default () => {
  const pageHeader = document.querySelector('.js-page-header')
  const mobileHeader = document.querySelector('.js-mobile-header')
  const scrollThreshold = 50

  if (!pageHeader && !mobileHeader) return

  const onScroll = () => {
    const scrolled = window.scrollY > scrollThreshold

    if (pageHeader) {
      pageHeader.classList.toggle('is-scrolled', scrolled)
    }

    if (mobileHeader) {
      mobileHeader.classList.toggle('is-scrolled', scrolled)
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true })
  onScroll()
}
